// Module
var code = `<div class="svc-toolbox__item" data-bind="attr: { role: 'button', 'aria-label': item.tooltip, title: item.tooltip }, css: item.renderedCss, click: (target, event)=>{ target.model.click(event); return true;}, key2click">
  <span class="svc-toolbox__item-container">
    <!-- ko if: iconName -->
      <!-- ko component: { name: 'sv-svg-icon', params: { iconName: iconName, size: 'auto', css: 'svc-toolbox__item-icon', title: tooltip || title }  } -->
      <!-- /ko -->
    <!-- /ko -->
  </span>
  <!-- ko ifnot: isCompact -->
  <span class="svc-toolbox__item-title" data-bind="text: title"></span>
  <!-- /ko -->
  </div>
<!-- ko if: isCompact -->
<span class="svc-toolbox__item-banner" data-bind="click: (target, event)=>{ target.model.click(event); return true;}">
  <!-- ko component: { name: 'sv-svg-icon', params: { iconName: iconName, size: 'auto', css: "svc-toolbox__item-icon", title: tooltip || title }  } -->
  <!-- /ko -->
  <span data-bind="text: title"></span>
</span>
<!-- /ko -->
`;
// Exports
export default code;